import { ScarfProvider } from '@tabeo/scarf'
import { ScarfContextProvider, Toaster } from '@tabeo/scarf2'
import { Toaster as ScarfcnToaster } from '@tabeo/scarfcn/components/ui/sonner'
import { TooltipProvider } from '@tabeo/scarfcn/components/ui/tooltip'
import ErrorBoundary from 'components/ErrorBoundary'
import TailwindColorConfig from 'components/TailwindColorConfig'
import config from 'config'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import { BrowserRouter as Router } from 'react-router'
import { createGlobalStyle } from 'styled-components'
import Routes from './Router'

const CSSReset = createGlobalStyle`
@media print {
	.no-print  {
		display: none;
	}
}
body {
  line-height: 1.5;
}
`

function App() {
  return (
    <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <NuqsAdapter>
        <CSSReset />
        <ScarfProvider
          theme={{
            breakpoints: ['960px', '1400px'],
          }}
          pcaKey={config.PCA_API_KEY}
        >
          <ScarfContextProvider countryCode="gb" pcaKey={config.PCA_API_KEY}>
            <TailwindColorConfig />
            <TooltipProvider>
              <ErrorBoundary>
                <Routes />
              </ErrorBoundary>
            </TooltipProvider>
          </ScarfContextProvider>
        </ScarfProvider>
      </NuqsAdapter>
      <Toaster />
      <ScarfcnToaster />
    </Router>
  )
}

export default App
